<template lang="pug">
  SearchConditions(ref="SearchConditions" :initSearchCond="initSearchCond" @onChangeSearchConditions="onChangeSearchConditions")
    template(v-slot:conditions="{ conditions }")
      alert-box(ref="errorMsg")
      v-layout(wrap)
        v-flex(md2)
          MonthPicker(pickerLabel="支払年月" :initDate="conditions.paymentTargetYearMonth" :inputDate.sync="conditions.paymentTargetYearMonth")

        v-flex(md4)
          v-text-field(label="1次配送委託先" v-model="conditions.primaryDeliveryCompanyName")
        v-flex(md2)
          PaymentStatusSelect(:code.sync="conditions.paymentStatus" :filterPending="true" :clearable="false")
        v-flex(md2)
          FaxSendStatusSelect(:code.sync="conditions.faxSendStatus" :clearable="true")
        v-flex(md2)
          v-checkbox(label="FAX送信対象のみ表示" v-model="conditions.onlyFaxTarget" hide-details )
</template>

<script>
import SearchConditions from "@/components/common/search/SearchConditions";
import MonthPicker from "@/components/common/MonthPicker";
import DatePicker from "@/components/common/DatePicker";
import PaymentStatusSelect from "@/components/common/select/PaymentStatusSelect";
import FaxSendStatusSelect from "@/components/common/select/FaxSendStatusSelect";
import AlertBox from "@/components/common/AlertBox";
import * as Enum from "@/assets/js/enum";

export default {
  components: {
    SearchConditions,
    MonthPicker,
    DatePicker,
    FaxSendStatusSelect,
    PaymentStatusSelect,
    AlertBox
  },
  methods: {
    /**
     * Emit：検索条件 変更
     */
    onChangeSearchConditions(item) {
      this.nonDisplayMessage();
      this.$emit("onChangeSearchConditions", item);
    },
    /**
     * アラートボックス表示
     */
    displayMessage(errorMsg) {
      this.$refs.errorMsg.displayMessage(errorMsg);
    },
    /**
     * アラートボックス非表示
     */
    nonDisplayMessage() {
      this.$refs.errorMsg.nonDisplayMessage();
    },
    /**
     * 初期設定：子コンポーネント情報
     */
    initSearchCond() {
      return {
        conditions: {
          paymentTargetYearMonth: window.Common.Util.getYearMonthIsoFormat(),
          primaryDeliveryCompanyName: null,
          paymentStatus: Enum.BillingStatusType.TEMPORARY_CONFIRMED.code,
          faxSendStatus: null,
          onlyFaxTarget: false
        }
      };
    },
    /**
     * Event：子コンポーネントsubmit処理
     * ※最終的に子からemitでonChangeSearchConditions(item)に伝播される。
     */
    submit() {
      this.$refs.SearchConditions.submit();
    }
  }
};
</script>
